<template>
	<div class="w1200">
		<div class="association-brief-box">
			<div class="crumbs">
				<span><a href="#/">首页 ></a></span>
				<span>协会通知</span>
			</div>
			<div class="article-box w1000">
				<h2>清洁服务师培训师的培训（CSTTT）</h2>
				<p>北京建筑设施服务企业协会会长张红女士刚回到北京，就立刻组建三天两晚清洁服务师的培训师培训课程。</p>

				<p>对于培训教材，从策划《清洁服务技术》清洁行业国家职业技能考试教程，到现在将近一年的时间，终于在年末可以出版了。</p>

				<p>十年磨一剑，很多优秀的作品都是慢工出细活的打磨出来的。70万字的教程，涵盖了十大技法、十大场景、十大业态的清洁技术。</p>

				<p>目前，大多数清洁公司处于低技术和低管理的状态，因此，向前迈一步，走向高端技术，未来才能更上一级高端管理。</p>
				<div class="img">
					<img src="../assets/images/0001.jpg">
				</div>
				<p>从南走到北，对于清洁的认知不同，呈现的技术和结果也大不相同。培训的呈现表达是线上和线下。线上部分从小视频到课程视频。线下培训通过清洁服务师训练标准知识和技术，给予参训人员专业性培训师的训练。</p>

				<p>通过三天两晚的培训学习，使参训人员从原有清洁服务技术人员转变成为清洁技术培训师（技术方面）。并获得正确的清洁专业思维、专业技能训练，学会用最简单的方法教会别人清洁技术，包括一对一指导、一对多培训的演练。毕业学员能独立承担清洁服务师的培训工作（技术方面）。</p>
				<div class="img">
					<img src="../assets/images/0002.jpg">
				</div>
				
				<p>清洁服务涉及技术环节的教学内容，包括设备、工具的正确使用技法、药剂的最佳搭配，将全面提升学员的职业能力和技术水平。  以卫生间为例。卫生间清洁培训内容包括基础知识和技能操作。</p>



<p>技能操作包括：清洁准备、清洁步骤（十三步骤技法）、质量自检、注意事项。同时，对于卫生间设施中的洁具、隔断、墙面、地面、门窗等，有小清洁步骤环节，会给学员一一进行培训和指导。</p>
<div class="img">
					<img src="../assets/images/0003.jpg">
				</div>
<p>参训学员收获：《清洁服务技术》培训教程一套，成为清洁服务师培训师（CSTTT）。获得系统性、全面性、权威性的专业指导，专业测试认证，提升职业价值，终身复训。这将是改善生活方式的最佳选择。</p>
				
				<div class="msg2"><strong>报名参加联系人（微信）：</strong></div>
				<div class="msg2"><strong>刘丽娜   18010131047&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;010-83520973</strong></div>


			</div>
		</div>

	</div>

</template>

<script>
	import Vue from 'vue';
	export default {

		data() {
			return {}
		},
		methods: {

		},
		components: {}
	}
</script>

<style>
	@import "../assets/css/detail.css";
</style>


// WEBPACK FOOTER //
// src/components/Notice.vue